import React from "react";
import {Doughnut} from "react-chartjs-2";
import useTranslation from "../hooks/translations";

export default function DoughnutChart({ chartData }) {
  const translations = useTranslation();
  const plugin = {
    id: 'emptyDoughnut',
    afterDraw(chart, args, options) {
      const {datasets} = chart.data;
      const {color, width, radiusDecrease, text} = options;
      let hasData = false;

      for (let i = 0; i < datasets.length; i += 1) {
        const dataset = datasets[i];
        hasData |= dataset.data.length > 0;
      }

      if (!hasData) {
        const {chartArea: {left, top, right, bottom}, ctx} = chart;
        const centerX = (left + right) / 2;
        const centerY = (top + bottom) / 2;
        const r = Math.min(right - left, bottom - top) / 2;

        ctx.beginPath();
        ctx.lineWidth = width || 2;
        ctx.strokeStyle = color || 'rgba(234, 236, 244, 1)';
        ctx.arc(centerX, centerY, (r - radiusDecrease || 0), 0, 2 * Math.PI);
        ctx.stroke();

        ctx.font = '22px Arial';
        ctx.fillStyle = color;
        ctx.fillText(text, centerX - ctx.measureText(text).width / 2, centerY - 10);
      }
    }
  };

  return (
    <>
      <Doughnut
        data={chartData}
        plugins={[plugin]}
        options={{
          layout: {
            padding: 10
          },
          plugins: {
            legend: {
              display: true,
              align: 'center',
              position: 'right'
            },
            tooltip: {
              callbacks: {
                label: function(context) {
                  let label = context.dataset.label || '';
                  if (context.dataset.data && context.dataset.data[context.dataIndex]) {
                    label += ` ${new Intl.NumberFormat('sr-RS', {
                      style: 'currency',
                      currency: 'RSD'
                    }).format(context.dataset.data[context.dataIndex])}`;
                  }
                  return label;
                }
              }
            },
            emptyDoughnut: {
              color: 'rgba(33, 37, 41, 0.25)',
              width: 1,
              radiusDecrease: 20,
              text: translations.noData
            }
          }
        }}
      />
    </>
  );
}
